<template>
  <v-container>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="clients"
      sort-by="name"
      class="elevation-1"
      :search="search"
      :custom-filter="filterTable"
    >
      <template v-slot:top>
        <v-toolbar flat color="white" :extended="$vuetify.breakpoint.xs">
          <v-toolbar-title>{{ $t('Customers') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-if="!$vuetify.breakpoint.xs"
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('Search')"
            clearable
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            data-cy="button-new-customer"
            :icon="$vuetify.breakpoint.mdAndDown"
            color="primary"
            dark
            class="mb-2"
            @click.stop="dialog = true"
          >
            <span v-if="$vuetify.breakpoint.lgAndUp">{{ $t('New customer') }}</span>
            <v-icon v-if="$vuetify.breakpoint.mdAndDown" x-large>mdi-plus-circle</v-icon>
          </v-btn>
          <v-btn
            depressed
            color="secondary"
            outlined
            :loading="loadingExport"
            class="ml-5"
            @click="exportClients"
            >{{ $t("Export") }}
          </v-btn>
          <template v-if="$vuetify.breakpoint.xs" v-slot:extension>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('Search')"
              clearable
              single-line
              hide-details
            ></v-text-field>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item.address="{item}">
        {{item.street1}}
        <div v-if="item.street2">{{item.street2}}</div>
        <div v-if="item.street3">{{item.street3}}</div>
        {{item.postal_code}}
        {{item.city}}
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon class="mr-2" @click.stop="editItem(item)">mdi-pencil</v-icon>
        <v-icon @click.stop="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <add-edit-client-dialog v-model="dialog" @close="close"></add-edit-client-dialog>
  </v-container>
</template>

<script>
import snackbar from "@/mixins/snackbar";
import { mapState } from "vuex";
import AddEditClientDialog from "@/components/AddEditClientDialog";
import FileSaver from "file-saver";

export default {
  name: "ClientsIndex",
  components: { AddEditClientDialog },
  mixins: [snackbar],
  data() {
    return {
      loading: false,
      loadingExport:false,
      dialog: false,
      search: "",
      exportFields: ['Nom','Adresse','Agence']
    };
  },
  computed: {
    ...mapState({
      clients: (state) => state.clients.items,
      reseller: (state) => state.auth.user.id,
    }),
    headers() {
      return [
        {
          text: this.$t("Name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("Address"),
          align: "start",
          sortable: true,
          value: "address",
        },
        {
          text: this.$t("Entity"),
          align: "start",
          sortable: true,
          value: "reseller_entity.name",
        },
        {
          text: this.$t("Actions"),
          align: "center",
          value: "actions",
          sortable: false,
        },
      ];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.loading = true;
    this.$store
      .dispatch("clients/fetchAll")
      .then(() => (this.loading = false))
      .catch(() => (this.loading = false));
  },
  methods: {
    back() {
      this.$router.push({
        name: "Resellers Show",
        params: { id: this.$router.currentRoute.params.id },
      });
    },
    editItem(item) {
      this.$store.commit("clients/setEditedId", item.id);
      this.$store.commit("clients/setEditedItem", Object.assign({}, item));
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("Are you sure you want to delete this item ?"))) {
        this.$store
          .dispatch("clients/deleteItem", item.id)
          .then(() =>
            this.snackbar("success", this.$t("snackbar-message-client.deleted"))
          )
          .catch(() =>
            this.snackbar("error", this.$t("snackbar-message-client.error"))
          );
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.$store.dispatch("clients/resetEditedItem");
      }, 300);
    },
    filterTable(value, search, item) {
      const needle = search.toLowerCase();

      return (
        item.name.toLowerCase().includes(needle) ||
        item.street1?.toLowerCase().includes(needle) ||
        item.street2?.toLowerCase().includes(needle) ||
        item.street3?.toLowerCase().includes(needle) ||
        item.postal_code?.toLowerCase().includes(needle) ||
        item.city?.toLowerCase().includes(needle) ||
        item.country?.toLowerCase().includes(needle) ||
        item.reseller_entity.name.toLowerCase().includes(needle)
      );
    },
    exportClients(){
      this.loadingExport = true;
      try {
        var sep='sep=,'
        var csvStr = sep+ "\n" +this.exportFields.join(",") + "\n";
        this.clients.forEach((client) => {
          var nom = client.name
          var adresse = client.street1 + ((client.street2 == null) ? '' : client.street3 == null ? (" " + client.street2) : (" " + client.street2 + " " + client.street3)) + " " + client.postal_code + " " + client.city
          var agence = client.reseller_entity.name
          csvStr += `"${nom}"` + "," + `"${adresse}"` + ","  + `"${agence}"` + "\n";
        });
        var blob = new Blob(['\uFEFF',csvStr], {type: "text/csv;charset=utf-8;"});
        FileSaver.saveAs(blob, "exportClients.csv");
        this.loadingExport = false;
      } catch (error) {
        this.loadingExport = false;
      }      
    }
  },
};
</script>